module.exports = __webpack_public_path__ + "img/menu-icon.2d7843cd.svg";